(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminSurveyDisplaySettingsController', AdminSurveyDisplaySettingsController);

    function AdminSurveyDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        siteAssociateTypesCollection,
        $translate,
        recurrenceRulesService,
        assetScoreTypesCollection,
        contractManager,
        elbSettings,
        $state,
        module,
        modulesService,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'fm_survey_submission_type',
                'fm_submit_kpi_by_date',
                'survey_timeout',
                'survey_automated_stats_enabled',
                'sp_auto_submit_kpi',
                'sp_submit_kpi_by_date'
            ],
            siteAssociateTypesCollection: siteAssociateTypesCollection,
            $translate: $translate,
            recurrenceRulesService: recurrenceRulesService,
            assetScoreTypesCollection: assetScoreTypesCollection,
            contractManager: contractManager,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService,
            fileTypeService: fileTypeService
        });

        angular.extend(vm, base);
    }
})();
